import { useSearchParams } from 'react-router';
import IndividualDataContentV2 from './v2/IndividualDataContentV2';
import { FamilyProfileContent } from './v2/family/FamilyProfileContent';

export default function NonFinancialDataContent() {
  const [searchParams] = useSearchParams();

  if (searchParams.get('view') === 'family') {
    return <FamilyProfileContent />;
  }
  return <IndividualDataContentV2 />;
}
